// type

import { AES, enc } from "crypto-js";
import * as url from "../store/constant/Endpoints";

import icons from "helper/iconsHelper";

import {
  can_add_clients,
  can_edit_clients,
  can_view_clients,
  per_view_users,
  per_docor_report_view,
} from "../helper/permissionsCheck";
// icons

// let permissionUser = localStorage.getItem("LoginData");
// let permissions = JSON.parse(permissionUser)?.permissions;

let permissionUser = localStorage.getItem("data");

let decryptedData = null;
if (permissionUser) {
  try {
    // Code that may throw an exception
    decryptedData = AES.decrypt(permissionUser, url.encryptionSecret).toString(
      enc.Utf8
    );
    // ...
  } catch (error) {
    console.log(error, "er");
  }
}

const permissions = decryptedData
  ? JSON.parse(decryptedData)?.permissions
  : null;

const allowedPermissions =
  permissions && permissions.length !== 0
    ? permissions.map((permission) => permission?.permission)
    : [];

const permissionsAccessFunction = (brand) => {
  return (
    allowedPermissions &&
    allowedPermissions.length !== 0 &&
    allowedPermissions.some((permission) => permission.includes(brand))
  );
};
// ==============================|| MENU ITEMS - roles ||============================== //

// const flat = permissionsAccessFunction('company') ? {
const allreports = per_docor_report_view
  ? {
      id: "all-report",
      title: "Reports",
      icon: icons.users,
      type: "group",
      children: [
        per_docor_report_view
          ? {
              id: "all-report",
              title: "Doctor Reports",
              type: "item",
              url: "/reports/appointment-report",
              icon: icons.report,
              breadcrumbs: true,
            }
          : null,
      ].filter(Boolean),
    }
  : null;
export default allreports;
